import { render } from "./ChangelogDialog.vue?vue&type=template&id=3da04f56"
import script from "./ChangelogDialog.vue?vue&type=script&lang=js"
export * from "./ChangelogDialog.vue?vue&type=script&lang=js"

import "./ChangelogDialog.vue?vue&type=style&index=0&id=3da04f56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__